const mapaUtils = {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    posicionDefault: { lat: 20.976125, lng: -89.583279 }, // merida - parque
};

export default mapaUtils;